import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { getStoporders, deleteMember } from "../../actions/memberActions";

import { InputText } from "primereact/inputtext";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

import 'primereact/resources/themes/nova-light/theme.css';
import 'primereact/resources/primereact.css';
import 'primeicons/primeicons.css';
import "primeflex/primeflex.css";

class MemberList extends Component {
  constructor() {
    super();
    this.state = {
      loading: false,
      first: 0,
      totalRecords: 0,
      globalFilter: "",
      members: "",
      stoporders: "",
      member: "",
      errors: {},
    };
    this.addMember = this.addMember.bind(this);
    this.editMember = this.editMember.bind(this);
    this.deleteMember = this.deleteMember.bind(this);
    // this.onPage = this.onPage.bind(this);
  }

  componentDidMount() {
    this.setState({ loading: true });
    const { id } = this.props.security.user.tradeUnion

    this.props.getStoporders(id);
  }

  //life cycle hooks
  componentWillReceiveProps(nextProps) {
    if (nextProps.errors) {
      this.setState({ errors: nextProps.errors });
    }

    //const { stoporders } = nextProps.member;
    if (nextProps.member) {
      this.setState({

        // totalRecords: members.totalElements,
        //members: members.content,//.slice(0, 50),
        loading: false,
      });
    }
  }

  //   onPage(event) {
  //     this.setState({ loading: true });
  // const{members}=this.props.member;

  //     const { first, rows,page } = event;

  //     this.setState({
  //       first,
  //       members: members.content.slice(first, first+rows),
  //       loading: false,
  //     });
  // if(this.state.members.length===0 &&(members.number>0||members.number<members.totalPages)){
  //   this.setState({ loading: true });
  //   this.props.getStoporders(500*(members.number+1),members.number+1);
  //   this.setState({ loading: false });
  // }

  // }

  addMember() {
    this.props.history.push("/add-member");
  }
  editMember(memberId) {

    this.props.history.push(`/edit-member/${memberId}`);
  }

  deleteMember(memberId) {
    this.props.deleteMember(memberId);
  }

  render() {
    const { errors } = this.state;
    const { stoporders } = this.props.member;


    const header = (
      <div style={{ textAlign: "left" }}>
        <i className="pi pi-search" style={{ margin: "4px 4px 0 0" }}></i>
        <InputText
          type="search"
          onInput={(e) => this.setState({ globalFilter: e.target.value })}
          placeholder="Global Search"
          size="50"
        />
        <button
          className="btn btn-success  float-right"
          onClick={() => this.addMember()}
        >
          Add Member
        </button>
      </div>
    );

    const paginatorLeft = <Button icon="pi pi-refresh" />;
    const actionTemplate = (rowData, column) => {
      return (
        <div>
          <Button
            type="button"
            icon="pi pi-search"
            className="p-button-success"
            style={{ marginRight: ".2em" }}
          ></Button>
          <Button
            type="button"
            icon="pi pi-pencil"
            className="p-button-warning"
            onClick={() => this.editMember(rowData.id)}
            style={{ marginRight: ".3em" }}
          ></Button>
          <Button
            type="button"
            icon="pi pi-times"
            className="p-button-danger"
            onClick={() => this.deleteMember(rowData.id)}
          ></Button>
        </div>
      );
    };

    return (
      <div>
        <div className="container-fluid bg-light mt-3 ">

          <div className="card m-auto  shadow-lg rounded p-3">
            <h1 className="m-auto text-center display-4">Member List</h1>
            {errors.message && (
              <div className="alert alert-danger text-center" role="alert">
                {errors.message}
              </div>
            )}

            <div className="card">
              <DataTable value={stoporders} paginator={true} paginatorLeft={paginatorLeft} header={header}
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                rows={50} rowsPerPageOptions={[50, 100, 500]}
                loading={this.state.loading}
                autoLayout={true}
                globalFilter={this.state.globalFilter} emptyMessage="No records found" >

                {/* <DataTable
                  value={this.state.members}
                  
                  paginator
                  rows={50}
                  totalRecords="501"
                  header={header}
                  lazy
                  first={this.state.first}
                  onPage={this.onPage}
                  loading={this.state.loading}
                  globalFilter={this.state.globalFilter}
                  emptyMessage="No records found"
                >*/}
                {/*<DataTable value={this.state.members} paginator rows={50} totalRecords={this.state.totalRecords}
                        lazy first={this.state.first} onPage={this.onPage} loading={this.state.loading}>*/}
                <Column
                  field="firstname"
                  header="Firstname"

                />
                <Column
                  field="surname"
                  header="Surname"
                  filter={true}
                  filterPlaceholder="Surname starts with"
                />
                <Column
                  field="nationalId"
                  header="National Id"
                  filter={true}
                  filterPlaceholder="National Id starts with"
                />
                <Column field="gender" header="Gender" />
                <Column field="cellNumber" header="Cellnumber" />
                <Column field="email" header="Email" />
                <Column field="grade" header="Grade" />
                <Column field="institution" header="Institution" filter={true}
                  filterPlaceholder="Institution" />
                {/* <Column field="member.arrears" header="Arrears" />*/}
                <Column field="status" header="status" />
                <Column
                  body={actionTemplate.bind(this)}
                  header="Actions"
                  style={{ textAlign: "center" }}
                />
              </DataTable>
            </div>
          </div>
        </div>
      </div>

    );
  }
}
MemberList.propTypes = {
  getStoporders: PropTypes.func.isRequired,
  deleteMember: PropTypes.func.isRequired,

  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  member: state.member,
  security: state.security,
  errors: state.errors,
});

export default connect(mapStateToProps, { getStoporders, deleteMember })(
  MemberList
);
